import React from "react";
import PropTypes from "prop-types";
import Button from "../../../../core/modules/common/components/Button";
import noop from "../../../../core/modules/common/tools/noop";
import CheckboxTreeSelector from "../../../common/components/CheckboxTreeSelector";
import OnlySelectedFilterCheckbox from "../../../common/components/OnlySelectedFilterCheckbox";
import Icons from "../../../../core/modules/common/components/Icons";
import themeStyles from "../../../../materialUiTheme";

const PostalOperatorSelector = (props) => {
  const {
    title = "",
    selected = [],
    expanded = [],
    expandDisabled = false,
    onSelect = noop,
    onExpand = noop,
    onSelectAll = noop,
    onDeSelectAll = noop,
    isShowOnlySelected = false,
    onShowOnlySelected = noop,
    postalOperatorNodes = [],
    openSaveSelectionModal,
    originalPostalOperatorNodes = [],
    saveSelectionButtonHidden = false,
  } = props;

  return (
    <div className="operator-selector-container">
      {postalOperatorNodes.length ? (
        <CheckboxTreeSelector
          title={title}
          nodes={postalOperatorNodes}
          selected={selected}
          expanded={expanded}
          expandDisabled={expandDisabled}
          onSelect={onSelect}
          onExpand={onExpand}
          onSelectAll={onSelectAll}
          onDeSelectAll={onDeSelectAll}
          originalNodes={originalPostalOperatorNodes}
        />
      ) : (
        <div />
      )}

      <div className="operator-selector-footer">
        <OnlySelectedFilterCheckbox
          isShowOnlySelected={isShowOnlySelected}
          onShowOnlySelected={onShowOnlySelected}
          isDisabled={selected.length === 0}
        />
        {!saveSelectionButtonHidden ? (
          <Button
            {...themeStyles.operatorSelectors.button}
            text="app.save.selection.button.label"
            onClick={() => openSaveSelectionModal()}
            iconComponent={<Icons.DownloadIcon />}
          />
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

PostalOperatorSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  expanded: PropTypes.arrayOf(PropTypes.string),
  expandDisabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onExpand: PropTypes.func,
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  postalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  originalPostalOperatorNodes: PropTypes.arrayOf(PropTypes.object),
  isShowOnlySelected: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
  openSaveSelectionModal: PropTypes.func,
  saveSelectionButtonHidden: PropTypes.bool,
};

export default PostalOperatorSelector;
